import Vue from 'vue'

import PromoCodesVuex from './PromoCodesVuex'
import PromoCodeTypesVuex from './PromoCodeTypesVuex'

Vue.mixin(PromoCodeTypesVuex)
Vue.mixin(PromoCodesVuex)
